import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsTimeslot from 'graphql/fields/FieldsTimeslot'

const fields = {
	'guid': 'String',
	'timeslot_day': 'Int!',
	'timeslot_start': 'String!',
	'timeslot_end': 'String!',
	'capacity': 'Int',
	'kind': 'String!',
	'sub_kind': 'String!',
	'active': 'String',
	
	'building_guid': 'String',
	'floor_guid': 'String',
	'room_guid': 'String',
	'table_guid': 'String',
	
	'translations': '[TranslationInputType]'
};

export default gql(`
	mutation timeslot( ${ HelperGraphql.createFields( fields ) } ) {
	    timeslot( ${ HelperGraphql.createVariables( fields ) } ) {
	        ${FieldsTimeslot}
	    }
	}
`);

